define('home/views/GenericCardCreateView',[
    'backbone-marionette',

    'home/mixins/asGenericCard',
    'home/mixins/withReason',
    'home/mixins/withSubviews',
    'home/views/PostCollectionView',

    'home/templates/genericCardCreate',
], function (
    Marionette,

    asGenericCard,
    withReason,
    withSubviews,
    PostCollectionView,

    genericCardCreateTemplate
) {
    'use strict';

    var parent = Marionette.ItemView;


    var GenericCardCreateView = parent.extend({
        template: genericCardCreateTemplate,
        templateHelpers: function () {
            return {
                recentPostCount: this.model.thread.recentPosts.length,
            };
        },

        regions: {
            postsRegion: '[data-role=posts]',
        },

        onRender: function () {
            this.activateRegion(this.postsRegion, this.createPostsView);
        },

        createPostsView: function () {
            return new PostCollectionView({
                el: this.postsRegion.el,
                collection: this.model.thread.recentPosts,
            });
        },
    });


    var proto = GenericCardCreateView.prototype;
    asGenericCard.call(proto);
    withReason.call(proto);
    withSubviews.call(proto);

    return GenericCardCreateView;
});

